import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as whom from "./style.module.scss";

export const Whom = ({ video, poster }) => {
  React.useEffect(() => {
    const vid = document.querySelector('video');
    vid.controls = false;
    vid.addEventListener('click', function() {
      if (vid.paused) {
        vid.play();
      } else {
        vid.pause();
      }
    });
  }, []);
  return (
    <section className={whom.whom}>
      <div className="container">
        <h2 className={main.titleH2}>Если вашему ребёнку:</h2>
        <div className={whom.whom__points}>
          <div className={whom.whom__point}>трудно самостоятельно организовать свое время;</div>
          <div className={whom.whom__point}>не&nbsp;хватает мотивации, чтобы пройти курс до&nbsp;конца;</div>
          <div className={whom.whom__point}>легче осваивать новый материал в&nbsp;группе единомышленников;</div>
          <div className={whom.whom__point}>для плодотворной работы нужны дедлайны и&nbsp;контроль.</div>
        </div>
        <div className={whom.whom__block}>
          <div className={whom.whom__quote}>Кураторское сопровождение&nbsp;&mdash; удачное решение.</div>
          <div className={whom.organized}>
            <div className={whom.organized__title}>Как организовано:</div>
            <div className={whom.organized__block}>
              <div className={whom.organized__blockItem}>
                <strong>Чат в&nbsp;Телеграме</strong> на&nbsp;10-15 учеников и&nbsp;куратора
              </div>
              <div className={whom.organized__blockItem}>
                Занятия <strong> 5&nbsp;раз в&nbsp;неделю</strong> по&nbsp;30&nbsp;минут
              </div>
            </div>
          </div>
          <div className={whom.whom__img}>
            <video
              className={whom.whom__imgVideo}
              src={ video }
              poster={ poster }
              width={'360px'}
              controls
            >
              <track kind={"captions"}/>
            </video>
          </div>
        </div>
      </div>
    </section>
  );
};
